// inbox
export const MESSAGE_FETCH_SUCCESS = 'MESSAGE_FETCH_SUCCESS';
export const MESSAGE_FETCH_ERROR = 'MESSAGE_FETCH_ERROR';
export const ALL_MESSAGES_FETCH_SUCCESS = 'ALL_MESSAGES_FETCH_SUCCESS';
export const ALL_MESSAGES_FETCH_ERROR = 'ALL_MESSAGES_FETCH_ERROR';

export const CHANGE_READ_STATUS_SUCCESS = 'CHANGE_READ_STATUS_SUCCESS';
export const CHANGE_READ_STATUS_ERROR = 'CHANGE_READ_STATUS_ERROR';

// outbox
export const OUTBOX_FETCH_SUCCESS = 'OUTBOX_FETCH_SUCCESS';
export const OUTBOX_FETCH_ERROR = 'OUTBOX_FETCH_ERROR';

// draft
export const ADD_FRIEND_TO_DRAFT_SUCCESS = 'ADD_FRIEND_TO_DRAFT_SUCCESS';
export const ADD_FRIEND_TO_DRAFT_ERROR = 'ADD_FRIEND_TO_DRAFT_ERROR';
export const ADD_TEXT_TO_DRAFT_SUCCESS = 'ADD_TEXT_TO_DRAFT_SUCCESS';
export const ADD_TEXT_TO_DRAFT_ERROR = 'ADD_TEXT_TO_DRAFT_ERROR';
export const ADD_IMAGE_TO_DRAFT_SUCCESS = 'ADD_IMAGE_TO_DRAFT_SUCCESS';
export const ADD_IMAGE_TO_DRAFT_ERROR = 'ADD_IMAGE_TO_DRAFT_ERROR';
export const REMOVE_IMAGE_FROM_DRAFT_SUCCESS = 'REMOVE_IMAGE_FROM_DRAFT_SUCCESS';
export const REMOVE_IMAGE_FROM_DRAFT_ERROR = 'REMOVE_IMAGE_FROM_DRAFT_ERROR';
export const ADD_DATE_TO_DRAFT_SUCCESS = 'ADD_DATE_TO_DRAFT_SUCCESS';
export const ADD_DATE_TO_DRAFT_ERROR = 'ADD_DATE_TO_DRAFT_ERROR';
export const ADD_LOCATION_TO_DRAFT_SUCCESS = 'ADD_LOCATION_TO_DRAFT_SUCCESS';
export const ADD_LOCATION_TO_DRAFT_ERROR = 'ADD_LOCATION_TO_DRAFT_ERROR';
export const DRAFT_CREATE_SUCCESS = 'DRAFT_CREATE_SUCCESS';
export const DRAFT_CREATE_ERROR = 'DRAFT_CREATE_ERROR';

// currentUser
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_ERROR = 'LOGOUT_ERROR';
export const REGISTER_SUCCESS = 'LOGIN_SUCCESS';
export const REGISTER_ERROR = 'LOGIN_ERROR';
export const REFRESH_TOKEN_SUCCESS = 'REFRESH_TOKEN_SUCCESS';
export const REFRESH_TOKEN_ERROR = 'REFRESH_TOKEN_ERROR';
export const REFRESHING_TOKEN = 'REFRESHING_TOKEN';
export const REFRESHING_TOKEN_DONE = 'REFRESHING_TOKEN_DONE';

// updateUser
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_ERROR = 'UPDATE_USER_ERROR';
export const UPDATE_AVATAR_SUCCESS = 'UPDATE_AVATAR_SUCCESS';
export const UPDATE_AVATAR_ERROR = 'UPDATE_AVATAR_ERROR';

// friends
export const FRIENDS_FETCH_SUCCESS = 'FRIENDS_FETCH_SUCCESS';
export const FRIENDS_FETCH_ERROR = 'FRIENDS_FETCH_ERROR';

// users
export const USERS_FETCH_SUCCESS = 'USERS_FETCH_SUCCESS';
export const USERS_FETCH_ERROR = 'USERS_FETCH_ERROR';

// friend requests
export const FRIEND_REQUESTS_FETCH_SUCCESS = 'FRIEND_REQUESTS_FETCH_SUCCESS';
export const FRIEND_REQUESTS_FETCH_ERROR = 'FRIEND_REQUESTS_FETCH_ERROR';
export const SEND_FRIEND_REQUEST_SUCCESS = 'SEND_FRIEND_REQUEST_SUCCESS';
export const SEND_FRIEND_REQUEST_ERROR = 'SEND_FRIEND_REQUEST_ERROR';
export const ANSWER_FRIEND_REQUEST_SUCCESS = 'ANSWER_FRIEND_REQUEST_SUCCESS';
export const ANSWER_FRIEND_REQUEST_ERROR = 'ANSWER_FRIEND_REQUEST_ERROR';

export const ADD_FRIEND_SUCCESS = 'ADD_FRIEND_SUCCESS';
export const ADD_FRIEND_ERROR = 'ADD_FRIEND_ERROR';

// statistics
export const INCOMING_MESSAGES_FETCH_SUCCESS = 'INCOMING_MESSAGES_FETCH_SUCCESS';
export const INCOMING_MESSAGES_FETCH_ERROR = 'INCOMING_MESSAGES_FETCH_ERROR';
export const OUTGOING_MESSAGES_FETCH_SUCCESS = 'OUTGOING_MESSAGES_FETCH_SUCCESS';
export const OUTGOING_MESSAGES_FETCH_ERROR = 'OUTGOING_MESSAGES_FETCH_ERROR';

export const RECEIVED_MESSAGES_FETCH_SUCCESS = 'RECEIVED_MESSAGES_FETCH_SUCCESS';
export const RECEIVED_MESSAGES_FETCH_ERROR = 'RECEIVED_MESSAGES_FETCH_ERROR';
export const SENT_MESSAGES_FETCH_SUCCESS = 'SENT_MESSAGES_FETCH_SUCCESS';
export const SENT_MESSAGES_FETCH_ERROR = 'SENT_MESSAGES_FETCH_ERROR';

// notifications
export const CHANGE_FRIEND_NOTIFICATION_BADGE_SUCCESS = 'CHANGE_FRIEND_NOTIFICATION_BADGE_SUCCESS';
export const CHANGE_FRIEND_NOTIFICATION_BADGE_ERROR = 'CHANGE_FRIEND_NOTIFICATION_BADGE_ERROR';
export const CHANGE_MESSAGE_NOTIFICATION_BADGE_SUCCESS =
  'CHANGE_MESSAGE_NOTIFICATION_BADGE_SUCCESS';
export const CHANGE_MESSAGE_NOTIFICATION_BADGE_ERROR = 'CHANGE_MESSAGE_NOTIFICATION_BADGE_ERROR';

// reset store
export const RESET_ALL = 'RESET_ALL';
export const RESET_STORE = 'RESET_STORE';
